import { render, staticRenderFns } from "./resource-block-featured.vue?vue&type=template&id=b9f3215e"
import script from "./resource-block-featured.vue?vue&type=script&lang=ts"
export * from "./resource-block-featured.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports